module.exports = __webpack_public_path__ + "static/media/az.e9fb296a.svg";